import React, { useMemo } from 'react';
import { Space, Spinner, Button, Alert, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import { groupLocationsByFirstLetter } from '../helpers/index.js';
import { useRegionalCenters } from '../hooks/useRegionalCenters.js';
import modules_e5ab2127 from '../styles/RegionDialog.module.less.js';

const { Text } = Typography;
/**
 * @description RegionDialog component.
 *
 * @component
 * @example
 * ```jsx
 * <RegionDialog />
 * ```
 */
const RegionsList = React.forwardRef((props, ref) => {
    const { onSelect } = props;
    const cx = useStyles(modules_e5ab2127);
    const { data: locations, loading, error } = useRegionalCenters();
    const locationsGrouped = useMemo(() => (Array.isArray(locations) ? groupLocationsByFirstLetter(locations) : {}), [locations]);
    const handleSelect = (option) => (event) => {
        event.preventDefault();
        onSelect(option);
    };
    return (React.createElement("div", { ref: ref, className: cx('listWrapper') },
        loading ? (React.createElement(Space, { align: "center", justify: "center" },
            React.createElement(Spinner, { size: 28 }))) : (React.createElement("div", { className: cx('list') }, Object.keys(locationsGrouped).map((symbol) => (React.createElement("div", { key: symbol, className: cx('listItem') },
            React.createElement(Text, { size: 16, strong: true, className: "h-mb-8" }, symbol),
            React.createElement(Space, { size: 8, direction: "vertical" }, locationsGrouped[symbol].map((location) => (React.createElement(Button, { key: location.routeGar, "aria-label": location.alias, variant: "text", className: cx('regionButton'), onClick: handleSelect(location) }, location.name))))))))),
        error ? React.createElement(Alert, { title: "\u041E\u0448\u0438\u0431\u043A\u0430", subtitle: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0433\u043E\u0440\u043E\u0434\u043E\u0432. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435." }) : null));
});
RegionsList.displayName = 'RegionsList';

export { RegionsList as default };
//# sourceMappingURL=RegionsList.js.map
